import { render, staticRenderFns } from "./PApplicationThanksModal.vue?vue&type=template&id=4aff4854&"
import script from "./PApplicationThanksModal.vue?vue&type=script&lang=ts&"
export * from "./PApplicationThanksModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports